function alertParameterDeliveryTypeController(alertsFrameworkService, deliveryTypeService) {
    const $ctrl = this;

    $ctrl.areDeliveryTypesLoading = false;

    $ctrl.$onInit = function () {
        loadDeliveryTypes();

        $ctrl.deliveryTypeIds = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
    };

    /* Handle Model Changes on the Parent */
    $ctrl.$onChanges = function(changes) {
        if (changes.model){
            const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
            const arraysEqual =
                newKeys.length === $ctrl.deliveryTypeIds.length
                && newKeys.every((value, index) => value === $ctrl.deliveryTypeIds[index]);

            if (!arraysEqual)
            {
                $ctrl.deliveryTypeIds = newKeys;
            }
        }
    }

    $ctrl.deliveryTypesChanged = (item, model) => {
        const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.deliveryTypeIds);

        $ctrl.onUpdate({csvValue: csvValue});
    };

    function loadDeliveryTypes() {
        $ctrl.areDeliveryTypesLoading = true;

        return deliveryTypeService
            .getDeliveryTypesV2($ctrl.subscriberKey,false,true)
            .then((deliveryTypes) => {
                $ctrl.deliveryTypes = deliveryTypes.toSorted((a, b) => {
                    const nameA = a.deliveryTypeName.toUpperCase();
                    const nameB = b.deliveryTypeName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    }

                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });

                $ctrl.areDeliveryTypesLoading = false;
            });
    }
}

angular
    .module("angus.components")
    .component("alertParameterDeliveryType", {
        controller: alertParameterDeliveryTypeController,
        bindings: {
            subscriberKey: "<",
            label: "<",
            model: "<",
            isReadOnly: "<",
            onUpdate: "&"
        },
        template: `
<label class="control-label" for="deliveryTypes">{{$ctrl.label || 'Delivery Types'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="areDeliveryTypesLoading"></i></label>

<ui-select 
    class="alert-select"
	multiple 
	ng-model="$ctrl.deliveryTypeIds" 
	ng-disabled="!$ctrl.deliveryTypes.length || $ctrl.isReadOnly" 
	on-select="$ctrl.deliveryTypesChanged($item, $model)" 
	on-remove="$ctrl.deliveryTypesChanged($item, $model)"
>
    <ui-select-match placeholder="Select delivery types...">{{$item.deliveryTypeName}}</ui-select-match>
    <ui-select-choices repeat="deliveryType.deliveryTypeKey as deliveryType in $ctrl.deliveryTypes | filter: {deliveryTypeName: $select.search}">
        {{deliveryType.deliveryTypeName}}</ui-select-choices>
</ui-select>
		`
    });
